export default ".indent {\n  padding-left: 12px;\n  background: grey;\n}\n.indent .mdc-list-item {\n  background: white;\n  border-left: 1px solid #eeeeee;\n}"